import React, { Component } from 'react'

export default class GhostLoginPopup extends Component {
    constructor(props) {
        super(props)
        this.state = {
            rolesType: [
                { assign: "sio", name: "Industry Admin", value: false },
                { assign: "press", name: "Press Admin", value: false },
                { assign: 'general', name: 'General Admin', value: false },
                { assign: 'sundanceGuest', name: 'Sundance Guest Admin', value: false },
            ],
            roleWiseFilterData: []
        }
    }

    componentDidMount() {
        let newRolesType = []
        this.state.rolesType.forEach((item, i) => {
            if (this.props.user && this.props.user.additionalRoles.includes(item.assign)) {
               newRolesType.push(item)
            }
        })
        
        this.setState({rolesType: newRolesType})
    }

     //role wise filter
     handleRole = (e, selectedInex) => {
        let index = selectedInex
        let event = e.target.checked
        let roleArray = [...this.state.rolesType]
        roleArray[selectedInex].value = event
        roleArray.forEach((item, i) => {
            if (i !== index) {
                item.value = false
            }
        })
        this.setState({
            ...this.state,
            rolesType: roleArray,
        }, () => {
        })
    };
    render() {
        const { rolesType } = this.state
        return (
            <div className='user_popup active role_reset_popup'>
            <span className="popup_overlay" onClick={this.props.closePopup}></span>
            <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                <p className='text_center pt_25'>Login as</p>
                <div className="approve_popup_header text_center relative">
                    <div className="customCheck">
                        {rolesType.map((item, i) => (
                            <div className="customCheckBox">
                                <input
                                    type="checkbox"
                                    id={item.name+i}
                                    name={item.name}
                                    value={item.value ? true : false}
                                    checked={item.value ? true : false}
                                    onChange={(e) => this.handleRole(e, i)}
                                />
                                <label htmlFor={item.name+i}>{item.name}</label>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="content">
                    <div className="field_row text_center">
                        <button className="active" onClick={() => this.props.ghostLogin(this.props.user, rolesType.filter(_ => _.value === true)[0].assign)}>Login</button>
                    </div>
                </div>
            </div>
        </div>
        )
    }
}